<template>
	<div id="commentManagement">
		<div class="container">
			<!-- <div class="companyInfo">
				<div class="company_avatar">
					<img v-if="schoolInfo.logo" :src="schoolInfo.logo"></img>
					<div class="company_name" v-else>
						{{schoolInfo.company_name?schoolInfo.company_name.substring(0,1):''}}
					</div>
				</div>
				<div class="companyInfoRight">
					<div class="companyInfoName">
						{{ schoolInfo.company_name || '校招平台用户' }}
					</div>
					<div class="tags">
						<div class="item" v-if="schoolInfo.industry">
							{{schoolInfo.industry || ''}}
						</div>
						<div class="item" v-if="schoolInfo.scale">
							{{schoolInfo.scale || ''}}
						</div>
					</div>
				</div>
			</div> -->


			<div class="stateContainer">
				<div class="left">
					<div class="headerContainer">
						<div class="title">社区统计</div>
					</div>
					<div class="numContainer" v-if="nextToken">
						<div class="text">点赞数</div>
						<div class="num">{{ visitData.like_cnt }}</div>
					</div>
					<div class="xian" v-if="nextToken"></div>
					<div class="numContainer" v-if="nextToken">
						<div class="text">评论数</div>
						<div class="num">{{ visitData.comment_cnt }}</div>
					</div>
				</div>
				<div class="right">
					<el-button type="primary" @click="issue">发布评论</el-button>
				</div>
			</div>
		</div>
		<div class="list">
			<div class="listContainer" v-if="rlist.length>0">
				<div class="item" v-for="(item, index) in rlist" :key="index">
					<!-- <div class="left">
						
					</div> -->

					<div class="right">
						<div class="main">
							<div class="mainLeft">
								<div class=""
									style="display: flex;align-items: center;justify-content: space-between;margin-bottom: 15px;">
									<div class="" style="display: flex;align-items: center;">
										<div class="logo">
											<img v-if="item.avatar" :src="item.avatar" alt="" />
											<img :src="`https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/11/20/avatar_${item.user_id % 26}.png`"
												v-else alt="" />
										</div>
										<div class="nameContainer">
											<div class="name">{{ item.username }}</div>
											<div class="tag" v-if="item.school_name">

												{{ item.school_name }}{{ item.graduation_year?'·'+item.graduation_year:''}}
											</div>
											<!-- item.level === 1 ? ' · 大一' : item.level === 2 ? ' · 大二' : item.level === 3 ? ' · 大三' : item.level === 4 ? ' · 大四' : ' · 大四' -->
											<!-- <div class="tag" style="opacity: 0;" v-else>
												12
											</div> -->
										</div>
									</div>
									<div class="time">{{ item.create_time | replaceTime }}</div>
								</div>


								<div class="msg">{{ item.word }}</div>
								<div class="image-box flex-h">
									<div v-for="i in item.imglist" :key="i" class="item-img">
										<!-- @click.stop="videoPlay(i)" -->
										<div class="item-v item-v-box" v-if="i.indexOf('.mp4') > -1"
											@click="handlePreview2(i, 2)">
											<video class="item-v" style="z-index: 0;width:124px;height: 100px;" :src="i"
												mode=""></video>
											<div class="item-v-bg"></div>
										</div>
										<!-- @click.stop="previewImage(i,item.imglist)" -->
										<img class="item-v" @click="handlePreview2(i, 1)" v-else :src="i" mode="" />
									</div>
								</div>
								<div class="like flex-h" v-if="item.likes.length > 0">
									<img src="../img/like.png" alt="" />
									<span v-for="(k, kindex) in item.likes" :key="k.id"
										class="txt">{{ kindex === item.likes.length - 1 ? k.username : k.username + '，' }}</span>
								</div>

								<div class="comment" v-if="item.comments.length > 0">
									<div :style="aindex === 0 ? 'margin-top:0' : ''"
										v-for="(i, aindex) in item.comments" :key="aindex" class="flex-h content-item"
										@click="replyAsk(i, item, index, aindex)">
										<img :style="aindex > 0 ? 'opacity:0' : ''" src="../img/commentator.png"
											alt="" />
										<div v-if="!i.to_user_id" class="com-title">{{ i.username || '无名' }}：</div>
										<div v-else class="com-title">{{ i.username }} 回复 {{ i.to_username }}：</div>
										<div class="commentContent">{{ i.content }}</div>
									</div>
								</div>

							</div>

							<div class="btnContainer">
								<div class="abtn" style="background: #E5EFFF;color:#2F5EC1;"
									@click="openReply(item, 2)">去回复</div>
								<div class="abtn" style="color: #1CA04B;"
									:style="item.lickAdminId.indexOf(adminId) > -1 ? 'background: rgba(153,153,153,0.3);color:#999;' : 'background: #DCFCE7;'"
									@click="agree(item)">{{ item.lickAdminId.indexOf(adminId) > -1 ? '已点赞' : '点赞' }}
								</div>
								<div class="abtn" style="color: #CC7E47;"
									:style="item.is_top ? 'background: rgba(153,153,153,0.3);color:#999;' : 'background: #FFEDD5'"
									@click="toTopup(item)">{{ item.is_top ? '已置顶' : '置顶' }}</div>
								<div class="abtn" style="background:#FDE2E1;color: #CE6060;"
									@click="deleteReview(item)">删除</div>


							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-else>

				<div style="height: 600px; padding-top: 100px">
					<el-empty :img-size="200" description="暂无评论"></el-empty>
				</div>

			</div>
		</div>
		<!-- <div class="paging">
      <div class="pagingLeft">
        <el-button plain @click="previousPage">上一页</el-button>
        <el-button plain @click="nextPage">下一页</el-button>
        <el-button type="danger" plain>删除</el-button>
      </div>
      <el-pagination background layout="total,prev, pager, next,jumper" :page-size="pageSizes" :total="total" @current-change="currentChange" :current-page="currentPage"> </el-pagination>
    </div> -->
		<!-- <el-dialog :visible.sync="dialogVisible" width="600px" height="800px">
			<div class="elDialog">
				<div class="main">
					<div class="userName">发布评论</div>
					<el-input type="textarea" auto-complete="" :rows="10" placeholder="请输入内容" v-model="textTxt"
						maxlength="400" show-word-limit></el-input>
					<div class="title-img">上传图片/视频</div>
					<el-upload action="https://np.sx985.com/admin/upload/uploadOssFile?admin_id=3"
						list-type="picture-card" :on-preview="handlePreview" :on-remove="handleRemove"
						:on-success="handleSuccess" :on-progress="handleProgress" :on-change="handleChange"
						:before-upload="beforeUpload" :file-list="fileList" :limit="9" :on-exceed="handleExceed">
						<i class="el-icon-plus"></i>

						<div slot="file" slot-scope="{ file }">
							<img v-if="file.raw.type.startsWith('image/')" class="el-upload-list__item-thumbnail"
								:src="file.url" alt="" />
							<div v-else-if="file.raw.type.startsWith('video/')">
								<video v-if="file.uploadPercentage > 99 || file.uploadPercentage == 0"
									class="el-upload-list__item-thumbnail" :src="file.url" controls></video>
								<div v-else class="upload-loading" style="margin-left: 200px">
									<el-progress type="circle" :percentage="file.uploadPercentage || 0"
										:width="80"></el-progress>
								</div>
					
							</div>
							<span class="el-upload-list__item-actions">
								<span class="el-upload-list__item-preview" @click="handlePreview(file)">
									<i class="el-icon-zoom-in"></i>
								</span>
								<span class="el-upload-list__item-delete" @click="handleRemove(file)">
									<i class="el-icon-delete"></i>
								</span>
							</span>
						</div>
					</el-upload>
					<div class="" style="display: flex;justify-content: flex-end;">
						<el-button class="" type="primary" style="margin-top: 50px" @click="sureBtn">提交发布</el-button>
					</div>
				</div>
			</div>
		</el-dialog> -->

		<div class="previewDialogVisible" id="videoDialog3">
			<el-dialog :visible.sync="dialogVisible" :show-close='false' :close-on-click-modal='false' width="500px" class="previewDialogVisible">
				<div class="previewElDialog elDialogContainer"
					style="background: #fff;background: #FFFFFF;border-radius: 10px;padding: 20px 0;">
					<img class="close" @click="dialogVisible = false" src="../img/close.png" alt="" />
					<div class=""
						style="line-height: 24px;font-size: 18px;color: #303133;font-weight: bold;padding: 0 20px;margin-bottom: 20px;">
						发布评论
					</div>
					<div class="elDialogContainer" style="background: #f7f9ff;padding: 20px 0;">
						<div class="ipt" style="align-items: baseline;padding: 0 20px;">
							<div class="text" style="margin-bottom: 0px;margin-bottom: 20px;">
								<span style="color:#FF4A4A">*</span>评论内容：
							</div>
							<el-input type="textarea" autosize auto-complete="" :rows="10" placeholder="请输入内容"
								v-model="textTxt" maxlength="400" show-word-limit></el-input>

						</div>

						<div class="ipt" style="padding: 0 20px;">
							<div class="text" style="margin-bottom: 0px;margin-bottom: 20px;">
								上传图片/视频：
							</div>
							<div class="enterprise" style="display: flex;align-items: center;">
								<el-upload action="https://np.sx985.com/admin/upload/uploadOssFile?admin_id=3"
									list-type="picture-card" :on-preview="handlePreview" :on-remove="handleRemove"
									:on-success="handleSuccess" :on-progress="handleProgress" :on-change="handleChange"
									:before-upload="beforeUpload" :file-list="fileList" :limit="9"
									:on-exceed="handleExceed">
									<i class="el-icon-plus"></i>
									<!-- 上传按钮 -->

									<!-- 自定义文件卡片内容 -->
									<div slot="file" slot-scope="{ file }">
										<!-- 图片展示 -->
										<img v-if="file.raw.type.startsWith('image/')"
											class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
										<!-- 视频展示 -->
										<!-- 视频展示 -->
										<div v-else-if="file.raw.type.startsWith('video/')">
											<video v-if="file.uploadPercentage > 99 || file.uploadPercentage == 0"
												class="el-upload-list__item-thumbnail" :src="file.url" controls></video>
											<div v-else class="upload-loading" style="margin-left: 200px">
												<el-progress type="circle" :percentage="file.uploadPercentage || 0"
													:width="80"></el-progress>
											</div>
											<!-- <div class="upload-loading" style="margin-left:200px">
								                  <el-progress type="circle" :percentage="file.uploadPercentage || 0" :width="80"></el-progress>
								                </div> -->
										</div>
										<!-- 操作按钮 -->
										<span class="el-upload-list__item-actions">
											<span class="el-upload-list__item-preview" @click="handlePreview(file)">
												<i class="el-icon-zoom-in"></i>
											</span>
											<span class="el-upload-list__item-delete" @click="handleRemove(file)">
												<i class="el-icon-delete"></i>
											</span>
										</span>
									</div>
								</el-upload>
							</div>
						</div>
					</div>

					<div class=""
						style="display: flex;align-items: center;justify-content: flex-end;padding: 20px 20px; 0 20px;">
						<el-button type="primary" @click="sureBtn">提交发布</el-button>
					</div>

				</div>
			</el-dialog>
		</div>



		<div class="previewDialogVisible" id="videoDialog3">
			<el-dialog :visible.sync="dialogVisible1" :show-close='false' :close-on-click-modal='false' width="500px" class="previewDialogVisible">
				<div class="previewElDialog elDialogContainer"
					style="background: #fff;background: #FFFFFF;border-radius: 10px;padding: 20px 0;">
					<img class="close" @click="dialogVisible1 = false" src="../img/close.png" alt="" />
					<div class=""
						style="line-height: 24px;font-size: 18px;color: #303133;font-weight: bold;padding: 0 20px;margin-bottom: 20px;">
						回复{{review_username}}
					</div>
					<div class="elDialogContainer" style="background: #f7f9ff;padding: 20px 0;">
						<div class="ipt" style="align-items: baseline;padding: 0 20px;">
							<div class="text" style="margin-bottom: 0px;margin-bottom: 20px;">
								内容：
							</div>
							<el-input type="textarea" autosize auto-complete="" :rows="10" placeholder="请输入内容"
								v-model="reviewtextTxt1" maxlength="400" show-word-limit></el-input>
						</div>
					</div>

					<div class=""
						style="display: flex;align-items: center;justify-content: flex-end;padding: 20px 20px; 0 20px;">
						<el-button type="danger" @click="delComment" v-if="showBtn">删除评论</el-button>
						<el-button type="primary" @click="sureBtn1">提交发布</el-button>
					</div>

				</div>
			</el-dialog>
		</div>





		<div>
			<!-- 图片预览对话框 -->
			<div class="videoDialog2"></div>
			<el-dialog :visible.sync="imageDialogVisible" width="800px">
				<img style="width:90%;display:block;margin:20px auto 5px" :src="dialogImageUrl" alt="" />
			</el-dialog>

			<!-- 视频预览对话框 -->
			<div class="videoDialog1">
				<el-dialog :visible.sync="videoDialogVisible" width="800px">
					<video width="100%" style="width: 720px;height:405px;margin: 20px auto;display: block;" controls
						:src="dialogVideoUrl"></video>
				</el-dialog>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		trim
	} from 'jquery'
	import {
		mapMutations,
		mapState
	} from 'vuex'
	// import { reviewList, uniReviewList, getVisitTotal, postTopReview, schoolJobReply, delComment, schoolJobLike, editCompanyReview, delReview } from '@/api/job.js'
	export default {
		data() {
			return {
				fileList: [], // 文件列表
				dialogImageUrl: '', // 预览图片的 URL
				dialogVideoUrl: '', // 预览视频的 URL
				imageDialogVisible: false, // 图片预览对话框是否显示
				videoDialogVisible: false, // 视频
				// fileList:[],
				// dialogImageUrl: '',
				dialogVisible: false,
				disabled: false,
				textTxt: '',
				// dialogVisible: false,
				rlist: [],
				rlist1: [],
				loading: false,
				total: 100,
				pageSizes: 9,
				currentPage: 1,
				lickAdminId: [],
				uploadStatus: true,
				visitData: {
					comment_cnt: 0,
					like_cnt: 0,
				},

				review_id: 0,
				// currentPage: 1,

				review_username: '',
				reviewtextTxt1: '',
				dialogVisible1: false,

				showBtn: false

			}
		},
		filters: {
			replaceTime(val) {
				if (val) {
					return val.substring(0, 4) + '年' + val.substring(5, 7) + '月' + val.substring(8, 10) + '日 ' + val
						.substring(11, 16)
				} else {
					return ''
				}
			},
		},
		computed: {
			...mapState({
				nextToken: state => state.nextToken,
				userinfo: state => state.userInfo,
				schoolData: state => state.schoolData,
				schoolInfo: state => state.schoolData,
				adminId: state => state.schoolData.admin_id,
			}),
			// hasLogin() {
			// 	return this.$store.getters.nextToken
			// },
			// userinfo() {
			// 	return this.$store.getters.userinfo
			// },
			// adminId() {
			// 	return this.$store.getters.adminId
			// },
			// schoolData() {
			// 	return this.$store.getters.schoolData
			// },
		},
		mounted() {
			// this.$util.post(
			// 	"/login/login", {
			// 		username: this.ruleForm.username,
			// 		password: this.$md5(this.ruleForm.pass),
			// 	},
			// 	(res) => {
			// 		
			// 		if (res.code == 1) {
			// 			localStorage.setItem("token", res.data.token);
			// 			this.$router.push({
			// 				path: "/main",
			// 				// query: {
			// 				//   id: 1,
			// 				// },
			// 			});
			// 		}
			// 	}
			// );
			this.getVisitTotal()
			this.reviewList(this.adminId)
		},
		methods: {
			...mapMutations(['setIslogin']),
			issue() {
				console.log(this.nextToken)
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}

				this.dialogVisible = true
			},
			// 上传前的校验
			beforeUpload(file) {
				// if(this.fileList.length>9){
				// 	this.$message.warning('最多只能上传 9 个文件！')
				// 	return false
				// }
				const isImage = file.type.startsWith('image/')
				const isVideo = file.type.startsWith('video/')
				if (!isImage && !isVideo) {
					this.$message.error('只能上传图片或视频文件！')
					return false
				}
				return true
			},
			// 文件状态改变时的处理
			handleChange(file, fileList) {
				this.fileList = fileList.map((item) => {
					if (item.raw) {
						// 生成临时 URL 用于预览
						item.url = URL.createObjectURL(item.raw)
						if (item.raw.type.startsWith('video/')) {
							item.loading = true // 设置 loading 状态
							item.uploadPercentage = 0 // 初始化上传进度
						}
					}
					return item
				})

			},
			// 上传进度事件
			handleProgress(event, file) {
				const currentFile = this.fileList.find((item) => item.uid === file.uid)
				if (currentFile) {
					currentFile.uploadPercentage = Math.floor(event.percent) // 更新上传进度


					if (currentFile.response) {
						currentFile.loading = false
						file.uploadPercentage = 100
					}
				}
				this.uploadStatus = false
			},
			// 上传成功事件
			handleSuccess(response, file) {
				file.loading = false
				const currentFile = this.fileList.find((item) => item.uid === file.uid)

				if (currentFile) {
					// currentFile.loading = false; // 取消 loading 状态
					this.$forceUpdate()
				}
				if (currentFile.response) {
					currentFile.loading = true
					file.uploadPercentage = 100
					this.$forceUpdate()
				}
				this.uploadStatus = true

			},
			deleteReview(item) {
				let that = this
				this.$confirm('确定要删除当前分享吗?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
					})
					.then(() => {
						this.$message({
							type: 'success',
							message: '删除成功!',
						})
						this.$util.post(
							"v2/school_job/delReview", {
								id: item.id,
							},
							(res) => {
								if (res.code === 0) {
									that.reviewList(this.adminId)
									that.getVisitTotal()
								}
							}
						);
						// delReview(item.id).then((res) => {
						// 	if (res.code === 0) {
						// 		that.reviewList(69407 || this.adminId)
						// 	}
						// })
					})
					.catch(() => {
						// this.$message({
						// 	type: 'info',
						// 	message: '已取消删除',
						// })
					})
			},
			// 删除文件
			handleRemove(file) {

				this.fileList = this.fileList.filter((item) => item.uid !== file.uid) // 更新文件列表
			},
			// 预览文件
			handlePreview(file) {
				if (file.raw.type.startsWith('image/')) {
					this.dialogImageUrl = file.url // 设置预览图片的 URL
					this.imageDialogVisible = true // 显示图片预览对话框
				} else if (file.raw.type.startsWith('video/')) {
					this.dialogVideoUrl = file.url // 设置预览视频的 URL
					this.videoDialogVisible = true // 显示视频预览对话框
				}
			},
			// 预览图片视频文件
			handlePreview2(item, type) {
				if (type === 1) {
					this.dialogImageUrl = item // 设置预览图片的 URL
					this.imageDialogVisible = true // 显示图片预览对话框
				} else {

					this.dialogVideoUrl = item // 设置预览视频的 URL
					this.videoDialogVisible = true // 显示视频预览对话框
				}
			},
			// 超出上传数量限制时的处理
			handleExceed() {
				this.$message.warning('最多只能上传 9 个文件！')
			},
			handleDownload(file) {

			},
			toTopup(item) {
				let is_top = 0
				if (item.is_top === 0) {
					is_top = 1
				} else {
					is_top = 0
				}

				this.$util.post(
					"v2/school_job/is_top_review", {
						is_top: is_top,
						id: item.id,
					},
					(res) => {
						if (res.code === 0) {
							if (is_top) {
								this.$message({
									type: 'success',
									message: '置顶成功',
								})
							} else {
								this.$message({
									type: 'success',
									message: '已取消置顶',
								})
							}

							this.reviewList(this.adminId)
							this.getVisitTotal()
						}
					}
				);
				// postTopReview(item.id, is_top).then((res) => {
				// 	if (res.code === 0) {
				// 		if (is_top) {
				// 			this.$message({
				// 				type: 'success',
				// 				message: '置顶成功',
				// 			})
				// 		} else {
				// 			this.$message({
				// 				type: 'success',
				// 				message: '已取消',
				// 			})
				// 		}

				// 		this.reviewList(69407 || this.adminId)
				// 	}
				// })
			},
			sureBtn() {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}

				this.textTxt = this.textTxt.trim()
				if (!this.textTxt) {
					this.$message({
						type: 'error',
						message: '请输入内容',
					})
					return
				}
				if (!this.uploadStatus) {
					this.$message({
						type: 'error',
						message: '图片/视频上传未完成，请稍后',
					})
					return
				}
				let fileImg = ''
				if (this.fileList.length > 0) {
					let files = this.fileList.map((item) => {
						if (item.response) {
							return item.response.data.fileUrl
						} else {
							return ''
						}
					})
					fileImg = files.toString()
				}
				// 

				let obj = {
					id: 0,
					admin_id: this.adminId,
					user_id: this.adminId,
					word: this.textTxt,
					picture: fileImg,
					video: '',
					username: this.schoolData.company_name,
					avatar: this.schoolData.logo || '',
					type: 2,
					// ask_type: this.ask_type,
					url: '',
					filename: '',
				}
				this.$util.post(
					"v2/school_job/editCompanyReview", {
						...obj,
					},
					(res) => {
						if (res.code === 0) {
							this.$message({
								type: 'success',
								message: '提交成功',
							})
							this.reviewList(this.adminId)
							this.getVisitTotal()
							this.dialogVisible = false
							// this.$uniapp.toast(res.msg)

							this.textTxt = ''
							this.fileList = []
						} else {
							this.$message({
								type: 'info',
								message: res.msg,
							})
							// this.$uniapp.toast(res.msg)
						}


					}
				);
				// editCompanyReview(obj)
				// 	.then((res) => {
				// 		if (res.code === 0) {
				// 			this.$message({
				// 				type: 'success',
				// 				message: '提交成功',
				// 			})
				// 			this.reviewList(69407 || this.adminId)
				// 			this.dialogVisible = false
				// 			// this.$uniapp.toast(res.msg)
				// 		} else {
				// 			this.$message({
				// 				type: 'info',
				// 				message: res.msg,
				// 			})
				// 			// this.$uniapp.toast(res.msg)
				// 		}
				// 	})
				// 	.finally(() => {
				// 		uni.hideLoading()
				// 	})

			},
			userAsk(txt) {
				console.log(this.org_name)
				let obj = {
					type: 2,
					review_id: this.review_id,
					content: txt,
					user_id: this.adminId,
					// user_id: this.userinfo.user_id,
					to_user_id: this.to_user_id,
					admin_id: this.adminId,
					to_username: this.to_username,
					to_avatar: this.to_avatar,
					username: this.org_name,
					avatar: this.schoolInfo.logo,
				}
				// if (this.rightId === 2) {
				//   // let comData =JSON.parse(localStorage.getItem("companyData"))
				// }
				this.$util.post(
					"v2/school_job/reply", {
						...obj,
						source: 2,
					},
					(res) => {
						if (res.code === 0) {
							this.dialogVisible1 = false
							
							this.reviewtextTxt1 = ''
							this.isShowSend = false
							this.to_user_id = 0
							this.to_username = ''
							this.to_avatar = ''
							this.reviewList(this.adminId)
							this.getVisitTotal()
						}
					}
				);
				// schoolJobReply(obj).then((res) => {
				// 	if (res.code === 0) {
				// 		this.replyTxt = ''
				// 		this.isShowSend = false

				// 		this.to_user_id = 0
				// 		this.to_username = ''
				// 		this.to_avatar = ''
				// 		this.reviewList(69407 || this.adminId)
				// 	}
				// })
			},
			agree(item) {
				let obj = {
					type: 2,
					review_id: item.id,
					admin_id: this.adminId,
					user_id: this.adminId,
				}
				obj.username = item.org_name
				obj.avatar = ''

				this.$util.post(
					"v2/school_job/like", {
						...obj,
					},
					(res) => {
						if (res.code === 0) {
							this.reviewList(this.adminId)
							this.getVisitTotal()
						}
					}
				);
				// schoolJobLike(obj).then((res) => {
				// 	if (res.code === 0) {
				// 		this.reviewList(69407 || this.adminId)
				// 	}
				// })
			},
			replyAsk(its, item) {

				if (its.user_id === (this.adminId)) {

					this.commentId = its.id
					this.openReply(item)
					// this.selectStatus(its,item)
					return
				}
				if (its) {
					if (its.to_user_id) {
						this.to_user_id = its.to_user_id
						this.to_username = its.to_username
						this.to_avatar = its.to_avatar

					} else {
						this.to_user_id = its.user_id
						this.to_username = its.username
						this.to_avatar = its.avatar

						item.username = its.username
						this.commentId = its.id

						this.openReply(item, 1)
					}
					if (this.adminId === its.to_user_id) {
						this.to_user_id = its.user_id
						this.to_username = its.username
						this.to_avatar = its.avatar

					}

					// if(its.user_id === this.to_user_id){
					//     this.to_user_id = 0
					//     this.to_username = ''
					//     this.to_avatar = ''
					// }
				} else {
					this.to_user_id = 0
					this.to_username = ''
					this.to_avatar = ''

				}
				// this.commitNews(item, index)
			},
			sureBtn1() {
				this.userAsk(this.reviewtextTxt1)
			},
			delComment() {
				this.$util.post(
					"v2/school_job/delComment", {
						id: this.commentId,
					},
					(res) => {
						if (res.code === 0) {
							this.reviewList(this.adminId)
							this.getVisitTotal()
							this.dialogVisible1 = false
							// that.$emit('delAsk', its, item)
							this.$message({
								type: 'success',
								message: '已删除评论',
							})
						}
					}
				);
			},
			openReply(item, type) {
				let showBtn = true
				if (type === 2) {
					showBtn = false
				}
				this.showBtn = showBtn
				console.log(item)
				this.review_id = item.id
				this.review_username = item.username
				this.dialogVisible1 = true
				this.org_name = item.org_name
				this.to_username = item.to_username
				this.to_avatar = item.to_avatar
				this.to_user_id = item.to_user_id

				// console.log(item)

				// this.review_id = item.id
				// let that = this
				// this.$prompt('请输入您的回复内容', `回复：${item.username}`, {
				// 		confirmButtonText: '回复评论',
				// 		cancelButtonText: '删除评论',
				// 		inputPattern: /^(?!(\s+$)).+/,
				// 		inputType:'textarea',
				// 		distinguishCancelAndClose: true,
				// 		inputErrorMessage: '请输入回复内容',
				// 		showCancelButton: showBtn,
				// 	})
				// 	.then((res) => {
				// 		this.org_name = item.org_name
				// 		if (!type) {
				// 			this.to_username = item.to_username
				// 			this.to_avatar = item.to_avatar
				// 			this.to_user_id = item.to_user_id
				// 		}
				// 		that.userAsk(res.value)
				// 		this.$message({
				// 			type: 'success',
				// 			message: '回复成功',
				// 		})
				// 	})
				// 	.catch((rep) => {
				// 		if (rep === 'cancel') {
				// 			this.$util.post(
				// 				"v2/school_job/delComment", {
				// 					id: that.commentId,
				// 				},
				// 				(res) => {
				// 					if (res.code === 0) {
				// 						this.reviewList(this.adminId)
				// 						this.getVisitTotal()
				// 						// that.$emit('delAsk', its, item)
				// 						this.$message({
				// 							type: 'info',
				// 							message: '已删除评论',
				// 						})
				// 					}
				// 				}
				// 			);
				// 		}
				// 	})
			},
			reviewList() {
				this.loading = true
				this.$util.post(
					"v2/school_job/review_list", {
						admin_id: this.adminId,
						start_time: '',
						end_time: '',
					},
					(res) => {
						if (res.code === 200) {
							// this.lickAdminId = []
							res.data.forEach((item) => {
								if (item.picture) {
									item.imglist = item.picture.split(',')
								}
								if (item.likes.length > 0) {
									item.lickAdminId = item.likes.map((i) => {
										return i.user_id
									})
								} else {
									item.lickAdminId = []
								}
							})
							this.rlist = res.data

							if (res.data.length > 0) {
								// wx.setNavigationBarTitle({
								//     title: `${that.admin_name}`
								// })
							} else {
								// wx.setNavigationBarTitle({
								//     title: `${that.admin_name}`
								// })
							}
						}
						this.loading = false
					},(err)=>{
						console.log(err)
						this.loading = false
					}
				);
				// reviewList(69407 || this.adminId, '', '').then((res) => {
				// 	if (res.code === 200) {
				// 		let that = this
				// 		// this.lickAdminId = []
				// 		res.data.forEach((item) => {
				// 			if (item.picture) {
				// 				item.imglist = item.picture.split(',')
				// 			}
				// 			if (item.likes.length > 0) {
				// 				item.lickAdminId = item.likes.map((i) => {
				// 					return i.user_id
				// 				})
				// 			} else {
				// 				item.lickAdminId = []
				// 			}
				// 		})
				// 		this.rlist = res.data

				// 		if (res.data.length > 0) {
				// 			// wx.setNavigationBarTitle({
				// 			//     title: `${that.admin_name}`
				// 			// })
				// 		} else {
				// 			// wx.setNavigationBarTitle({
				// 			//     title: `${that.admin_name}`
				// 			// })
				// 		}
				// 	}
				// })
			},
			getVisitTotal() {
				this.$util.post(
					"v2/school_job/visit_total", {
						admin_id: this.adminId,
						start_time: '',
						end_time: '',
						type: 2,
					},
					(res) => {
						if (res.code === 0) {
							this.visitData = res.data
							// this.isShowTime = false
						}
					}
				);
				// getVisitTotal(69407 || this.adminId, '', '', 2)
				// 	.then((res) => {
				// 		if (res.code === 0) {
				// 			this.visitData = res.data
				// 			// this.isShowTime = false
				// 		}
				// 	})
				// 	.finally(() => {
				// 		// uni.hideLoading()
				// 	})
			},
			currentChange(page) {

				this.currentPage = page
				// this.getEnterpriseList()
			},
			previousPage() {
				if (this.currentPage > 1) {
					this.currentPage--
				}
			},
			nextPage() {
				if (Math.ceil(this.total / this.pageSizes) > this.currentPage) {
					this.currentPage++
				}
			},
		},
		components: {},
	}
</script>
<style>
	#videoDialog3 .previewDialogVisible .el-dialog {
		background: initial;
		box-shadow: initial;
	}

	#videoDialog3 .btnContainer .el-button+.el-button {
		margin-left: 0px !important;
	}

	#videoDialog3 .el-dialog {
		background: initial;
		box-shadow: initial;
		width: 480px !important;
		margin-top: 1vh !important;
	}

	#videoDialog1 .el-dialog {
		min-width: 810px !important;
		background: #ffffff;
		width: 820px !important;
	}

	#videoDialog2 .el-dialog {
		min-width: 810px !important;
		background: #ffffff;
		width: 820px !important;
	}

	/* #messageManagement .el-textarea__inner {
		border: none;
		resize: none !important;
		background: #f7f9ff !important;
	} */

	#videoDialog3 .el-upload-list__item-thumbnail {
		width: 120px !important;
		height: 120px !important;
		object-fit: cover;
		/* 保持图片/视频比例 */
	}

	#videoDialog3 .el-dialog__body {
		padding: 0 20px 30px 20px;
		box-sizing: border-box;
	}

	video {
		width: 100%;
		height: 100%;
		background-color: black;
		/* 视频背景色 */
	}

	#videoDialog3 .el-upload-list--picture-card .el-progress {
		top: 50%;
		left: 50%;
		transform: translate(-40px, -50%);
		bottom: auto;
		width: 80px;
	}

	#videoDialog3 .el-upload-list--picture-card .el-upload-list__item {
		width: 100px;
		height: 100px;
	}

	#videoDialog3 .el-upload--picture-card {
		width: 100px;
		height: 100px;
		/* line-height: 100px; */
	}

	#videoDialog3 .el-upload--picture-card i {
		/* line-height: 100px; */
	}

	#videoDialog3 .el-dialog__body {
		padding: 10px 20px 30px 20px;
	}

	.new-btn {
		color: #fff;
		background-color: #409eff;
		border-color: #409eff;
		width: 80%;
		margin-left: 10%;
		/* border-radius: 40px; */
	}

	/* .upload-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%; 
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明背景 */
	/* } */
</style>
<style lang="less" scoped>
	.container {
		width: 100%;
		padding: 0 40px;

		.headerContainer {
			// width: 100%;
			padding: 20px 0 20px 0;
			// border-bottom: 1px solid #EEEEEE;
			display: flex;
			align-items: center;
			// margin-bottom: 25px;

			.title {
				margin-right: 20px;
				font-weight: bold;
				font-size: 16px;
				color: #333;
			}
		}

		.stateContainer {
			min-width: 1010px;
			// margin-bottom: 30px;
			display: flex;
			align-items: center;
			// padding-bottom: 18px;
			// border-bottom: 1px solid #e5e5e5;
			justify-content: space-between;

			.left {
				flex: 1;
				display: flex;
				align-items: center;

				.numContainer {
					display: flex;
					align-items: center;

					.text {
						font-weight: 500;
						font-size: 14px;
						color: #333;
						margin-right: 20px;
					}

					.num {
						font-weight: 500;
						font-size: 18px;
						color: #0057fd;
					}
				}

				.xian {
					height: 15px;
					border-right: 1px solid #e5e5e5;
					margin: 0 20px;
				}
			}
		}

		.list {
			padding: 0 40px 20px 40px;
			min-height: 400px;
		}

		.listContainer {
			// border-left: 1px solid #e5e5e5;
			// border-right: 1px solid #e5e5e5;
			// border-top: 1px solid #e5e5e5;
			width: 100%;
			min-width: 1010px;

			.item {
				background: #fff;
				min-width: 1010px;
				// border-bottom: 1px solid #e5e5e5;
				padding: 25px 30px;
				border-radius: 10px;
				margin-bottom: 10px;
				display: flex;
				// align-items: center;
				justify-content: space-between;

				.left {
					display: flex;

					// align-items: center;


					// .center{
					// 	flex: 1;
					// 	margin-right: 50px;

					// }
				}

				.right {
					flex: 1;
					display: flex;
					align-items: baseline;

					.logo {
						font-size: 0;
						position: relative;
						margin-right: 20px;

						img {
							width: 57px;
							height: 57px;
							border-radius: 50%;
							// background: #4f8ff0;
						}

						div {
							position: absolute;
							top: 0;
							right: 0;
							padding: 0px 5px;
							background: #ff5560;
							border-radius: 50%;

							font-weight: 400;
							font-size: 14px;
							color: #ffffff;
						}
					}

					.main {
						flex: 1;
						// display: flex;
						align-items: center;

						.mainLeft {
							flex: 1;
							// min-width: 450px;
							// max-width: 830px;

							.nameContainer {
								// display: flex;
								align-items: center;
								// margin-bottom: 10px;

								.name {
									font-weight: 500;
									font-size: 16px;
									color: #000;
									// margin-right: 17px;

								}

								.tag {
									margin-top: 10px;
									font-weight: 400;
									font-size: 14px;
									color: #333;
								}
							}

							.msg {
								min-width: 415px;
								font-weight: 400;
								font-size: 14px;
								line-height: 24px;
								color: #333;
								word-break: break-all;
								margin-bottom: 15px;
							}

							.like {
								align-items: center;
								font-size: 0;
								margin-bottom: 15px;
								// padding-left: 10px;
								flex-wrap: wrap;
								justify-content: flex-start;

								img {
									width: 18px;
									height: 18px;
									margin-right: 5px;
								}

								span {
									font-weight: 500;
									font-size: 14px;
									color: #6b7f9e;
								}
							}

							.comment {
								background: #F0F4FA;
								border-radius: 10px;
								// border: 1px solid #e5e5e5;
								// display: flex;
								// align-items: flex-start;
								padding: 15px 10px;
								margin-bottom: 15px;

								.content-item {
									align-items: stretch;
									margin-top: 10px;
									cursor: pointer;

									img {
										margin-right: 4px;
										width: 18px;
										height: 18px;
										margin-top: 2px;
									}

									.com-title {
										font-weight: 500;
										font-size: 14px;
										color: #6b7f9e;
									}

									.commentContent {
										flex: 1;
										word-break: break-all;
										font-weight: 500;
										font-size: 14px;
										color: #515356;
									}
								}

								// .commentator {
								//   font-size: 0;
								//   display: flex;
								//   align-items: center;
								// }
							}
						}

						.time {
							width: auto;
							font-weight: 400;
							font-size: 14px;
							color: #AEAEAE;
							// margin-top: 40px;
							// margin: 0 auto;
							// min-width: 200px;
							// padding-left: 10px;
							margin-bottom: 15px;
						}
					}

					.btnContainer {
						// display: grid;
						// grid-template-columns: repeat(4, 96px);
						// grid-gap: 14px 14px;
						display: flex;
						align-items: center;

						.abtn {
							color: #fff;
							font-weight: 500;
							padding: 5px 10px;
							font-size: 14px;
							// font-weight: 500;
							margin-right: 10px;
							border-radius: 5px;
							text-align: center;
							cursor: pointer;
						}
					}

					// width: 96px;
					// height: 37px;
					// background: #4F8FF0;
					// border-radius: 5px;

					// text-align: center;
					// line-height: 37px;
					// font-weight: bold;
					// font-size: 14px;
					// color: #FFFFFF;
				}
			}
		}
	}

	.paging {
		width: 100%;
		padding: 20px 25px;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.pagingLeft {
			display: flex;
			align-items: center;
		}
	}

	.elDialog {
		position: relative;
		font-size: 0;
		z-index: 1;

		.main {
			box-sizing: border-box;
			padding: 0 0 0 0;
			background: #ffffff;
			border-radius: 10px;

			.userName {
				padding: 10px 0 30px 0;
				font-weight: bold;
				font-size: 16px;
				color: #333;
				// text-align: center;s
			}

			.title-img {
				font-size: 16px;
				font-weight: 500;
				margin-top: 10px;
				margin-bottom: 10px;
			}
		}

		.close {
			position: absolute;
			top: -60px;
			right: -52px;
			width: 32px;
			height: 32px;
			cursor: pointer;
			z-index: 2;
		}
	}

	.image-box {
		flex-wrap: wrap;
		justify-content: flex-start;
		padding: 0 0;
		box-sizing: border-box;

		.item-img {
			width: 124.8px;
			height: 100px;
			// margin-top: 10px;
			margin-bottom: 10px;
			margin-right: 10px;
			border-radius: 10px;

			.item-v {
				width: 124.8px;
				height: 100px;
				border-radius: 10px;
			}

			.item-v-box {
				position: relative;

				.item-v-bg {
					position: absolute;
					width: 124.8px;
					height: 100px;
					left: 0;
					top: 0;
					// background: red;
				}
			}
		}

		// .item-img:nth-of-type(3n) {
		//   margin-right: 0;
		// }
	}

	.companyInfo {
		width: 100%;
		padding: 20px 0 20px 0;
		border-bottom: 1px solid #EEEEEE;
		font-size: 0;
		display: flex;
		align-items: center;
		margin-bottom: 5px;

		// img {
		// 	width: 57px;
		// 	height: 57px;
		// 	border-radius: 50%;
		// 	background: #003987;
		// 	margin-right: 10px;
		// }

		.companyInfoRight {
			display: flex;
			justify-content: center;
			flex-direction: column;

			.companyInfoName {
				font-weight: 500;
				font-size: 18px;
				color: #2D3C50;
				margin-bottom: 10px;
			}

			.tags {
				display: flex;
				align-items: center;

				.item {
					padding: 2px 4px;
					border-radius: 5px;
					border: 1px solid #AEAEAE;
					font-weight: 500;
					font-size: 12px;
					color: #AEAEAE;
					margin-right: 5px;
				}
			}
		}
	}

	.previewElDialog {
		position: relative;
		font-size: 0;

		.main {
			box-sizing: border-box;
			padding: 30px 50px 50px 50px;
			background: #FFFFFF;
			border-radius: 10px;

			.title {
				font-weight: bold;
				font-size: 16px;
				color: #2A2929;
				margin-bottom: 30px;
			}
		}

		.close {
			position: absolute;
			top: -28px;
			right: -28px;
			width: 32px;
			height: 32px;
			cursor: pointer;
		}
	}

	.elDialogContainer {

		.ipt {
			width: 440px;
			// display: flex;
			// align-items: center;
			margin-bottom: 28px;

			.text {
				// width: 135px;
				display: flex;
				align-items: center;
				font-weight: 400;
				font-size: 16px;
				color: #000;
				margin-bottom: 20px;
			}

			.el-input {
				flex: 1 !important;
			}

			.el-select {
				flex: 1 !important;
			}

			.el-textarea {
				flex: 1 !important;
			}




		}


	}
</style>